export default __webpack_public_path__ + "static/media/qrcode-site-2048w.4b579034.webp";